module.exports = __webpack_public_path__ + "img/t_0005.0edea686.gif";